import { UserOrganizationsResource } from '~/resources';

// Persists the Insights "Workforce Analytics" banner dismissal via dismiss_promotion, echoing the
// payload the server put in `initialState`. Shared by DashboardWorkforceBanner and the settings banner.
export default {
  methods: {
    async dismissInsightsWorkforceBanner() {
      const userOrganizationId = this.initialState?.user_organization_id;
      const dismiss = this.initialState?.insights_banner_dismiss;

      if (!userOrganizationId || !dismiss) {
        return;
      }

      try {
        const response = await UserOrganizationsResource.dismissPromotion(
          { id: userOrganizationId },
          { dismiss },
          { abortReload: true },
        );

        // Validation failures come back as HTTP 200 {success:false, errors} (matches PromotionBanners.js).
        if (response?.errors) {
          this.$appMessage('Error dismissing the banner.');
        }
      } catch (error) {
        if (![401, 403].includes(error?.status)) {
          this.$appMessage('Error dismissing the banner.');
        }
      }
    },
  },
};
